import { yupResolver } from "@hookform/resolvers/yup";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Grid,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { API_URL } from "../consts";
import { Link as RouterLink } from "react-router-dom";

interface ChangePasswordDto {
  password: string;
  password2: string;
}
const schema = yup
  .object({
    password: yup.string().min(5).max(30).label("Password").required(),
    password2: yup
      .string()
      .label("Conferma Password")
      .oneOf([yup.ref("password"), null], "Deve coincidere con Password"),
  })
  .required();

export function ChangePassword() {
  let { id, token } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const idNum = parseInt(id ?? "-1");

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = useMutation(
    (data: ChangePasswordDto) => {
      return axios.post(API_URL + "auth/changePassword", {
        id: idNum,
        token,
        password: data.password,
      });
    },
    {
      onSuccess: () => {
        handleClickOpen();
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ChangePasswordDto>({
    mode: "all",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: ChangePasswordDto) => {
    mutate(data);
  };

  const isValid = !(id === undefined || token === undefined || idNum < 0);
  const title = isValid ? "Cambio Password" : "Link non valido!";

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          {title}
        </Typography>

        {isValid && (
          <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 2 }}>
            <Controller
              name="password"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  type="password"
                  label="Password"
                  error={Boolean(errors.password)}
                  helperText={errors.password?.message ?? " "}
                />
              )}
            />
            <Controller
              name="password2"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  type="password"
                  label="Conferma Password"
                  error={Boolean(errors.password2)}
                  helperText={errors.password2?.message ?? " "}
                />
              )}
            />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Cambia Password
            </Button>
          </Box>
        )}

        <Grid container>
          <Grid item xs>
            <Link to="/login" variant="body2" component={RouterLink}>
              Login
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Password modificata</DialogTitle>
        <DialogContent>
          <DialogContentText>La password è stata modifica.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
